// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBO7U7lkCkYpiUaHglUK6NqFjVN1RDn2sk",
    authDomain: "database-adminlogin.firebaseapp.com",
    projectId: "database-adminlogin",
    storageBucket: "database-adminlogin.appspot.com",
    messagingSenderId: "638809651761",
    appId: "1:638809651761:web:acfc18fe0a0840854ff310"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const database = getFirestore(app);
export default firebaseConfig